import {NavLinkConfig} from './nav-link-config';

export class Page {
    navConfig: NavLinkConfig;
    component: any;
    attributes: any;
}
